<template>
    <div style="height: 100%">
        <div v-if="!showMap" class="mapDummy">
            <button class="btn btn-primary mapDummyButton" @click="showMap = true">
                {{ $t('components.map.showObject') }}
            </button>
        </div>
        <GmapMap
            v-else
            class="google-map m-0 mb-12"
            :center="center"
            :zoom="zoom"
            :map-type-id="type"
            style="height: 100%;"
            :options="options"
        >
            <GmapMarker
                :position="center"
            />
        </GmapMap>
    </div>
</template>

<script>
export default {
    name: "Map",
    props: {
        center: {
            type: Object,
            required: true
        },
        zoom: {
            type: Number,
            required: false,
            default: 18
        },
        type: {
            type: String,
            required: false,
            default: "roadmap"
        }
    },
    data() {
        return {
            showMap: false,
            options: {
                panControl: true,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: true,
                overviewMapControl: true,
                clickableIcons: false,
                styles:[
                    {
                        'featureType': 'poi.business',
                        'stylers': [{'visibility': 'off'}]
                    }
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .mapDummy {
        position: relative;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('../../assets/map_small.png');
        background-size: cover;
        background-position: center;
    }

    .mapDummyButton {
        position: absolute;
        z-index: 10;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }

    .hide {
        display: none
    }
</style>